(function () {
  'use strict';

  function initAccordion(container) {
    if (container.dataset.accordionInitialized === 'true') return;
    container.dataset.accordionInitialized = 'true';

    var items = container.querySelectorAll('.eclat-acc__item');

    items.forEach(function (item, index) {
      var btn   = item.querySelector('.eclat-acc__trigger');
      var panel = item.querySelector('.eclat-acc__panel');
      if (!btn || !panel) return;

      if (!panel.id) panel.id = container.id + '-panel-' + index;
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', panel.id);
      panel.hidden = true;
      panel.style.maxHeight = '0';

      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        // Close all items
        items.forEach(function (other) {
          var ob = other.querySelector('.eclat-acc__trigger');
          var op = other.querySelector('.eclat-acc__panel');
          if (ob) ob.setAttribute('aria-expanded', 'false');
          if (op) {
            op.style.maxHeight = '0';
            op.hidden = true;
          }
        });

        // If it was closed, open it
        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
          // Make the collapsed state measurable before animating it open.
          void panel.offsetHeight;
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.eclat-accordion').forEach(initAccordion);
  });

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.eclat-accordion').forEach(initAccordion);
  });
})();
